import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TelemonitoringGalleryService } from '@modules/gallery/services/dialogs/sliders/telemonitorings/telemonitoring-gallery.service';
import { PatientAvatarComponent } from '@modules/patient/patient-avatar/patient-avatar.component';
import { PatientDataComponent } from '@modules/patient/patient-data/patient-data.component';
import { SequenceMediaComponent } from '@modules/sequence/sequence-media/sequence-media.component';
import { ActionButtonsComponent } from '@modules/shared/action-buttons/action-buttons.component';
import { ArchivedBadgeComponent } from '@modules/shared/archived-badge/archived-badge.component';
import { ImageBrokenComponent } from '@modules/shared/image-broken/image-broken.component';
import { UserPreviewComponent } from '@modules/user/user-preview/user-preview.component';
import { FlattenedTelemonitoring, Telemonitoring } from '@pixacare/dtos';
import { MenuAction } from '@shared/models/menu-actions/menu-action';
import { LastActivityPipe } from '@shared/pipes/last-activity.pipe';
import { TuiLink } from '@taiga-ui/core';
import { TuiBadge, TuiStatus } from '@taiga-ui/kit';
import { TuiCardLarge } from '@taiga-ui/layout';
import { TelemonitoringNamePipe } from '../pipes/telemonitoring-name.pipe';

@Component({
  selector: 'pxc-telemonitoring-preview',
  templateUrl: './telemonitoring-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TuiCardLarge,
    UserPreviewComponent,
    TuiLink,
    TuiBadge,
    TuiStatus,
    ActionButtonsComponent,
    SequenceMediaComponent,
    ArchivedBadgeComponent,
    TranslocoDirective,
    TelemonitoringNamePipe,
    LastActivityPipe,
    PatientAvatarComponent,
    PatientDataComponent,
    ImageBrokenComponent,
  ],
})
export class TelemonitoringPreviewComponent {
  @Input() telemonitoring: FlattenedTelemonitoring;
  @Input() actions: MenuAction<Telemonitoring>[];
  @Input() displayPatient = true;

  @Output() clicked = new EventEmitter<void>();

  private readonly telemonitoringGalleryService = inject(TelemonitoringGalleryService);

  openQrCodeInGallery(): void {
    this.telemonitoringGalleryService.openGallery(
      this.telemonitoring.telemonitoring.clientCode,
      this.telemonitoring.telemonitoring.id,
    );
  }
}
